import { findMarketGroupByCategory } from './findMarketGroupByCategory';
import { getIsSelectionActive } from './getIsSelectionActive';
export const modifySlipSelections = (selectionsInSlip, byoMarketGroups) => {
    const modifiedSelections = {};
    for (const [key, selection] of Object.entries(selectionsInSlip)) {
        const marketGroup = findMarketGroupByCategory(byoMarketGroups, selection.category);
        const isSelectionActive = marketGroup ? getIsSelectionActive(marketGroup, selection) : selection.active;
        modifiedSelections[key] = Object.assign(Object.assign({}, selection), { active: isSelectionActive });
    }
    return modifiedSelections;
};
